import React from 'react';

const Dashboard = (props) => {
  return <></>
}

export default Dashboard;